import { useMemo } from 'react'

import { useCompanyId } from 'peach/scopes/company'

import { useUserPermissions_get } from 'core/types'

const useHasPermission = (permissionKey, options: any = {}) => {
  const { companyId: passedCompanyId } = options || {}
  const appCompanyId = useCompanyId()
  const companyId = passedCompanyId || appCompanyId

  const { data: permissions } = useUserPermissions_get({})

  const hashesByCompany = useMemo(
    () =>
      _.mapValues(permissions, (keyList) => {
        const hash = {}
        _.each(keyList, (key) => (hash[key] = true))
        return hash
      }),
    [permissions],
  )

  return hashesByCompany?.[companyId]?.[permissionKey]
}

export default useHasPermission
